import clsx from 'clsx';

import IconArrow from '@ui/components/icons/IconArrow';
import IconCheck from '@ui/components/icons/IconCheck';
import IconCross from '@ui/components/icons/IconCross';

export interface AvatarProps {
  imgSrc?: string;
  title: string;
  onClick?: () => void;
  type?: 'showModal' | 'item' | 'static';
  size?: 'regular' | 'small';
  isAvatarActive?: boolean;
  isAvatarVoted?: boolean;
  className?: string;
}
const Avatar = ({
  className,
  imgSrc,
  title,
  onClick,
  isAvatarActive = false,
  isAvatarVoted = false,
  type = 'item',
  size = 'regular',
}: AvatarProps) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'group/avatar relative rounded-full transition-all duration-300 motion-reduce:transition-none',
        type !== 'static' && 'cursor-pointer',
        size === 'regular' &&
          'h-[72px] min-h-[72px] w-[72px] min-w-[72px] md:h-[104px] md:min-h-[104px] md:w-[104px] md:min-w-[104px]',
        size === 'small' && 'h-[48px] min-h-[48px] w-[48px] min-w-[48px]',
        className,
      )}
    >
      <img src={imgSrc} alt={title} title={title} className="rounded-full" />
      <div
        className={clsx(
          'absolute inset-0 flex items-center justify-center rounded-full transition-all duration-300 motion-reduce:transition-none',
          type === 'item' && 'scale-100 group-hover/avatar:shadow-avatar-inner',
          isAvatarActive &&
            type === 'item' &&
            'scale-100 bg-brand-primary-10050 group-hover/avatar:shadow-none',
          !isAvatarActive && type === 'item' && 'scale-0',
          type === 'showModal' &&
            'scale-0 bg-brand-primary-10050 group-hover/avatar:scale-100',
          isAvatarVoted &&
            type === 'static' &&
            'scale-0 bg-brand-primary-10050 group-hover/avatar:scale-100',
        )}
      >
        {type === 'showModal' && <IconArrow className="fill-brand-white-100" />}
        {isAvatarActive && type === 'item' && (
          <IconCheck className="fill-brand-white-100" />
        )}
        {isAvatarVoted && type === 'static' && (
          <IconCross className="fill-brand-white-100" />
        )}
      </div>
    </div>
  );
};

export default Avatar;
